import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var SelectInfoBannerComponent = /** @class */ (function () {
    function SelectInfoBannerComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    return SelectInfoBannerComponent;
}());
export { SelectInfoBannerComponent };
